import { useTranslation } from '@crehana/i18n';
import { InverseButton } from '@crehana/ui';

const B2BLoginButton = () => {
  const { t } = useTranslation();
  return (
    <>
      <InverseButton
        className="md:hidden"
        label={t('LOGIN_WITH_YOUR_ORGANIZATION')}
        href={'/business/entrar/'}
        size="s"
        full
        isWhite
      />
      <InverseButton
        className="hidden md:inline-flex"
        label={t('LOGIN_WITH_YOUR_ORGANIZATION_DESKTOP')}
        href={'/business/entrar/'}
        size="s"
        full
        isWhite
      />
    </>
  );
};

export default B2BLoginButton;
